import styled from "styled-components";
import { SPACING } from "../../utils/constants";

export const NetPreviewRow = styled.output`
  display: flex;
  justify-content: space-between;
  margin-top: ${SPACING.sm}px;
  font-size: var(--text-sm);
  color: var(--color-text-secondary);
  font-variant-numeric: tabular-nums;
`;
